import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectItem } from '@app/core/interfaces/admin.interface';
import { DiscountTypology } from '@app/shared/models/discount';
import { TranslateService } from '@ngx-translate/core';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-discount-typology-select',
  templateUrl: './discount-typology-select.component.html',
  styleUrls: ['./discount-typology-select.component.scss']
})
export class DiscountTypologySelectComponent {

  @Input() typologySelected: MultiselectItem[] = [];

  @Input() disabled: boolean = false;

  @Output() typologySelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  typeList: MultiselectItem[] = [];

  constructor(
    private translate: TranslateService,
  ) {

    this.typeList = [
      { id: DiscountTypology.STANDARD, itemName: this.translate.instant('multiselect.discountTypology.' + DiscountTypology.STANDARD) },
      { id: DiscountTypology.KEYWORD, itemName: this.translate.instant('multiselect.discountTypology.' + DiscountTypology.KEYWORD) }
    ]

  }

  onTypeSelect(): void {
    this.typologySelectedChange.emit(this.typologySelected);
    this.onSelected.emit(this.typologySelected);
  }

}
